import { GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';

export const isRetryable = (responseStatus?: number): boolean => {
  return responseStatus !== undefined && (responseStatus >= 500 || responseStatus === 200);
};

export const isMissingAssets = (data?: GiveawayResponse): boolean => {
  return data !== undefined && (!data.assets || data.assets.length === 0);
};

export const isMissingCameraFlight = (data?: GiveawayResponse): boolean => {
  return data !== undefined && data.renderCameraFlight === true && !data.cameraFlightVideo;
};
